import React, { FC } from "react";
import { Image, Tooltip } from "antd";
import useOrganizationAvatar from "./hooks/useOrganizationAvatar";

type CustomAvatarProps = {
  size: number | "large" | "small" | "default";
  placement?:
    | "top"
    | "left"
    | "right"
    | "bottom"
    | "topLeft"
    | "topRight"
    | "bottomLeft"
    | "bottomRight"
    | "leftTop"
    | "leftBottom"
    | "rightTop"
    | "rightBottom"
    | undefined;
};

const OrganizationAvatar: FC<CustomAvatarProps> = ({ size, placement }) => {
  const { image, organizationName } = useOrganizationAvatar();

  if (!image) {
    return null;
  }

  return (
    <Tooltip placement={placement} title={organizationName}>
      <Image width={size} src={image} preview={false} alt="Company" />
    </Tooltip>
  );
};

export default OrganizationAvatar;
